import { CheckCircle2 } from "lucide-react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

const benefits = [
  "Liberate your team from soul-crushing repetitive tasks",
  "Empower employees to focus on creative problem-solving",
  "Give CEOs and leaders time for strategic thinking",
  "Enable people to build relationships, not spreadsheets",
  "Free humans to do what humans do best - innovate and connect",
  "Create space for meaningful work that drives fulfillment",
];

export function Benefits() {
  return (
    <section id="benefits" className="bg-gray-950 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <div>
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
              alt="Analytics dashboard showing business metrics"
              className="h-auto w-full rounded-2xl shadow-xl ring-1 ring-blue-500/20"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-white">
              Why True Leaders Choose Brenneman Systems
            </h2>
            <p className="text-gray-400">
              We partner with companies that value their people. Our mission is
              to eliminate the busywork that drains energy and creativity, so
              employees and CEOs alike can be more human - focusing on
              innovation, relationships, and the work that truly matters.
            </p>

            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-6 w-6 flex-shrink-0 text-emerald-400" />
                  <span className="text-gray-300">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
